var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ConfirmDialog',{ref:"confirmDialog",attrs:{"accept-title":_vm.$t('leave'),"messages":[_vm.$t('warnings.unsavedChanges')],"popup-title":_vm.$t('warnings.confirmLeavePage'),"title":_vm.$t('warnings.areYouSureLeave')}})}
var staticRenderFns = []

export { render, staticRenderFns }